import 'css-chunk:../../frontend/phi3d/src/js/components/Modals/Welcome.module.scss';export default {
  "changelog": "_changelog_1ul13_1",
  "white": "_white_1ul13_8",
  "inset": "_inset_1ul13_8",
  "thumbnail": "_thumbnail_1ul13_15",
  "terms": "_terms_1ul13_30"
};